$(function() {

	var app = {

		vars: {
			logo: null
		},

		el: {
			doc: $(document),
			win: $(window),
			html: $('html'),
			body: $('body'),
			header: $('.site-header'),
			footer: $('.site-footer')
		},

		headerFixed: function() {
			var scroll_per = app.el.html.scrollTop()
			if (scroll_per > 1) {
				if (!app.vars.logo) {
					app.vars.logo = app.el.header.find('.site-header__logo').attr('src');
					app.el.header.find('.site-header__logo').attr('src', '/assets/images/muda.svg');
					app.el.header.addClass('site-header--fixed');
				}
			}
			else {
				if (app.vars.logo) {
					app.el.header.find('.site-header__logo').attr('src', app.vars.logo);
					app.el.header.removeClass('site-header--fixed');
					app.vars.logo = null;
				}
			}
		},

		init: function() {
			app.headerFixed()
			app.el.win.on('scroll', function() {
				app.headerFixed()
			})

			app.el.header.on('click', '.site-header__toggle', function() {
				app.el.header.toggleClass('site-header--open');
				app.el.footer.toggleClass('site-footer--open');
				app.el.body.toggleClass('disable-scroll');
			});

		}

	}
	app.init();
});